// src/utils/logger.js
// Logger centralizado con soporte para debugging en UAT

const isDebugEnabled = () => {
  if (typeof window === 'undefined') return false;

  const hostname = window.location.hostname;
  const urlParams = new URLSearchParams(window.location.search);

  return hostname.includes('uat') ||
         hostname.includes('localhost') ||
         localStorage.getItem('lemmontags_debug') === 'true' ||
         urlParams.get('debug') === 'true';
};

let debugEnabled = null;

export const logger = {
  debug: (...args) => {
    if (debugEnabled === null) debugEnabled = isDebugEnabled();
    if (debugEnabled) console.log('[DEBUG]', ...args);
  },
  info: (...args) => {
    if (debugEnabled === null) debugEnabled = isDebugEnabled();
    if (debugEnabled) console.info('[INFO]', ...args);
  },
  warn: (...args) => console.warn('[WARN]', ...args),
  error: (...args) => console.error('[ERROR]', ...args),

  enable: () => {
    localStorage.setItem('lemmontags_debug', 'true');
    debugEnabled = true;
    console.log('[LOGGER] Debug habilitado. Recarga la página.');
  },
  disable: () => {
    localStorage.removeItem('lemmontags_debug');
    debugEnabled = false;
    console.log('[LOGGER] Debug deshabilitado.');
  }
};

if (typeof window !== 'undefined') {
  window.lemmontags = { logger };
}
